import React from "react";

/* Fixed film-grain + faint stone wash overlay.
   Pointer-events disabled so the rest of the page is fully interactive. */
const GrainOverlay = () => (
  <>
    <div className="stone-wash" aria-hidden="true" />
    <div className="grain-overlay" aria-hidden="true" />
  </>
);

export default GrainOverlay;
